import { Box, Button, Container, Grid2, Stack, Typography } from "@mui/material";
import EmailIcon from '@mui/icons-material/Email';
import { CONTACT_EMAIL } from "../../constants";

function Join() {
  return (
    <Box sx={{ backgroundColor: "rgb(255, 255, 255);" }}>
      <Container sx={{ py: 4 }}>
        <Grid2 container spacing={2}>
          <Grid2 size={{ xs: 12, sm: 8 }}>
            <Stack spacing={2} alignItems="baseline">
              <Typography component="h2" variant="h4">Gå med</Typography>
              <Typography>Vill du synas på Sveriges karta över våra svenska pärlor, bli en pin hos oss!</Typography>
              <Typography>Bästa appen för dig som har en gårdsbutik, gårdscafé, mindre försäljning, loppis mm.</Typography>
              <Typography>Vi löser pin och flyer i vår app. Du kommer synas på våra sociala medier som uppdateras varje dag.</Typography>
              <Typography>Kontakta oss för mer info och priser</Typography>
              <Container sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center"
              }}>
                <Button
                  variant="contained"
                  startIcon={<EmailIcon />}
                  target="_top"
                  rel="noopener noreferrer"
                  href={`mailto:${CONTACT_EMAIL}`}>
                  Kontakta oss
                </Button>
              </Container>
            </Stack>
          </Grid2>
          <Grid2 size={{ xs: 12, sm: 4 }}>
            <Box
              component="img"
              sx={{
                height: "100%",
                width: "100%",
                maxHeight: 250,
                objectFit: "cover",
                borderRadius: "6px",
                filter: "drop-shadow(1px 1px 2px rgb(0 0 0 / 0.2))"
              }}
              alt="Bli en pin hos oss"
              src="/joinus.jpg"
            />
          </Grid2>
        </Grid2>
      </Container>
    </Box>
  )
}

export default Join;